import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import helpers from "helpers/helpers"
import translate from "translations/global"
import numeral from "numeral"
import FullTable from "components/FullTable"

class Cancels extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filtered: [],
			sorted: [],
		}
	}

	buildTable = () => {
		var ret = []
		if (_.has(this.props, "payload.bustouts.current")) {
			this.props.payload.bustouts.current.forEach((r) => {
				var v = {}
				let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				let builder = _.find(this.props.payload.public.builders, { id: r.builder })
				let type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
				v.salesperson = sp ? `${sp.first} ${sp.last}` : ""
				v.address = r.address
				v.builder = builder ? builder.name : ""
				v.sale_date = r.sale_date
				v.addedDate = r.bustout_report_time
				v.cancel_date = r.bustout_date
				v.lot_type = type ? type.name : ""
				v.property = (r.property && _.find(this.props.payload.public.properties, { id: r.property }).name) || ""
				v.lot_id = r.lot_id
				v.realtor_name = r.realtor_name ? _.startCase(r.realtor_name.toLowerCase()) : ""
				v.realtor_office_name = r.realtor_office_name ? _.startCase(r.realtor_office_name.toLowerCase()) : ""
				v.primary_first = r.primary_first
				v.primary_last = r.primary_last
				v.co_first = r.co_first
				v.co_last = r.co_last
				v.reason = r.bustout_reason
				v = helpers.translateObject(v, translate)
				v["Sale Type"] = r.start_date < r.sale_date ? "Spec" : "Dirt"
				ret.push(v)
			})
		}
		ret = _.sortBy(ret, "bustout_date").reverse()
		return ret
	}

	buildCancelRates = () => {
		let ret = []
		let store = {}
		let p = this.props.payload
		let model = {
			cancels: 0,
			gross: 0,
		}
		_.forEach(this.props.payload.bustouts.current, (v) => {
			try {
				let property = _.find(p.public.properties, { id: v.property })
				let builder = _.find(p.public.builders, { id: v.builder })
				let type = _.find(p.public.lot_types, { id: v.lot_type })
				if (!builder || !type || !property) return
				builder.name = builder.name.replace(/[^\w- ]+/g, "")

				let path = `${property.name}.${builder.name}.${type.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[property.name][builder.name][type.name].cancels++
			} catch (e) {
				console.log(e)
			}
		})

		_.forEach(this.props.payload.sales.current, (v) => {
			try {
				let property = _.find(p.public.properties, { id: v.property })
				let builder = _.find(p.public.builders, { id: v.builder })
				let type = _.find(p.public.lot_types, { id: v.lot_type })
				if (!builder || !type || !property) return
				builder.name = builder.name.replace(/[^\w- ]+/g, "")

				let path = `${property.name}.${builder.name}.${type.name}`
				if (!_.has(store, path)) {
					_.setWith(store, path, _.clone(model), Object)
				}
				store[property.name][builder.name][type.name].gross++
			} catch (e) {
				console.log(e)
			}
		})

		_.forEach(store, (r1, Community) => {
			_.forEach(r1, (r2, Builder) => {
				_.forEach(r2, (v, type) => {
					ret.push({
						Community,
						Builder,
						"Lot Type": type,
						"Cancel Rate": v.cancels / v.gross || 0,
						"Gross Sales": v.gross,
						Cancels: v.cancels,
					})
				})
			})
		})

		return ret
	}

	buildTotalSales = () => {
		if (_.has(this.props, "payload.bustouts.current")) {
			let d = {}
			_.forEach(this.props.payload.bustouts.current, (v) => {
				if (!d[v.builder]) {
					d[v.builder] = 0
				}
				d[v.builder]++
			})
			return _.map(d, (t, b) => {
				b = parseInt(b)
				let builder = _.find(this.props.payload.public.builders, { id: b })
				if (!builder) return
				return (
					<li className="statBreakout__item" key={b}>
						<div>
							<div className="statBreakout__stat">{t}</div>
							<div className="statBreakout__info">{builder.name}</div>
						</div>
					</li>
				)
			})
		}
	}

	buildLotCancelRates = () => {
		let payload = this.props.payload
		let ret = []
		let store = {}
		_.forEach(payload.exec.busts, (v) => {
			let lot = _.find(payload.exec.lots, { id: v.lot_id })
			if (!lot || lot.closing_date) return
			let lotType = _.find(payload.public.lot_types, { id: lot.lot_type })
			let builder = _.find(payload.public.builders, { id: lot.builder })
			let property = _.find(payload.public.properties, { id: lot.property })
			if (!store[lot.address]) {
				store[lot.address] = {
					count: 0,
					id: v.lot_id,
					lot_type: lotType?.name,
					builder: builder?.name,
					property: property?.name,
				}
			}
			store[lot.address].count++
		})

		_.forEach(store, (v, address) => {
			ret.push({
				Community: v.property,
				Builder: v.builder,
				Address: address,
				"Lot Type": v.lot_type,
				Cancels: v.count,
			})
		})

		return ret
	}

	render() {
		const columns = [
			{
				Header: "Community",
				accessor: "Community",
				filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
			},
			{
				Header: "Address",
				accessor: "Address",
				filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
			},
			{
				Header: "Sales Person",
				accessor: "Salesperson",
				filterMethod: (f, r) => helpers.tableText(f, r, "Salesperson"),
			},
			{
				Header: "Buyer First",
				accessor: "Primary First",
				filterMethod: (f, r) => helpers.tableText(f, r, "Primary First"),
			},
			{
				Header: "Buyer Last",
				accessor: "Primary Last",
				filterMethod: (f, r) => helpers.tableText(f, r, "Primary Last"),
			},
			{
				Header: "Realtor",
				accessor: "Realtor Name",
				filterMethod: (f, r) => helpers.tableText(f, r, "Realtor Name"),
			},
			{
				Header: "Realtor Office",
				accessor: "Realtor Office",
				filterMethod: (f, r) => helpers.tableText(f, r, "Realtor Office"),
			},
			{
				Header: "Builder",
				accessor: "Builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
			},
			{
				Header: "Lot Type",
				accessor: "Lot Type",
				filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
			},
			{
				Header: "Sale Date",
				accessor: "Sale Date",
				Cell: (v) => {
					if (v.value) {
						return moment.unix(v.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
			{
				Header: "Sale Type",
				accessor: "Sale Type",
				filterMethod: (f, r) => helpers.tableText(f, r, "Sale Type"),
			},
			{
				Header: "Cancel Date",
				accessor: "Cancel Date",
				Cell: (v) => {
					if (v.value) {
						return moment.unix(v.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
				sort: "desc",
			},
			{
				Header: "Input Date",
				accessor: "Input Date",
				Cell: (v) => {
					if (v.value) {
						return moment.unix(v.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
				sort: "desc",
			},
			{
				Header: "Reason for Cancellation",
				accessor: "Cancel Reason",
				filterMethod: (f, r) => helpers.tableText(f, r, "Reason for Cancellation"),
			},
		]

		const columns_rates = [
			{
				Header: "Community",
				accessor: "Community",
				filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
			},
			{
				Header: "Builder",
				accessor: "Builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
			},
			{
				Header: "Lot Type",
				accessor: "Lot Type",
				filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
			},
			{
				Header: "Gross Sales",
				accessor: "Gross Sales",
				filterMethod: (f, r) => helpers.tableText(f, r, "Gross Sales"),
				Footer: (props) => helpers.tableTotals(props, "Gross Sales", "0,0"),
			},
			{
				Header: "Cancels",
				accessor: "Cancels",
				filterMethod: (f, r) => helpers.tableText(f, r, "Cancels"),
				Footer: (props) => helpers.tableTotals(props, "Cancels", "0,0"),
			},
			{
				Header: "Cancel Rate",
				accessor: "Cancel Rate",
				Cell: (v) => {
					return numeral(v.value).format("0.00%")
				},
				Footer: (props) => helpers.tableAverages(props, "Cancel Rate", "0.00%", { dontDivide: true }),
			},
		]

		const columns_lots = [
			{
				Header: "Community",
				accessor: "Community",
				filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
			},
			{
				Header: "Builder",
				accessor: "Builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
			},
			{
				Header: "Address",
				accessor: "Address",
				filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
			},
			{
				Header: "Lot Type",
				accessor: "Lot Type",
				filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
			},
			{
				Header: "Cancels",
				accessor: "Cancels",
				filterMethod: (f, r) => helpers.tableText(f, r, "Cancels"),
				Footer: (props) => helpers.tableTotals(props, "Cancels", "0,0"),
			},
		]

		if (this.props.payloadStatus) {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Cancels" />
						<div className="statBreakout">
							<div className="statBreakout__group">
								<h3 className="statBreakout__title">
									{numeral(this.props.payload.bustouts.current.length).format("0,0")} Cancels{" "}
									<span>
										for {this.props.currentDates.startText} - {this.props.currentDates.endText}
									</span>
								</h3>
								<ul className="statBreakout__list">{this.buildTotalSales()}</ul>
							</div>
						</div>
						<div className="content">
							<h2>
								{this.props.currentDates.startText} - {this.props.currentDates.endText}
							</h2>
							<FullTable data={this.buildTable()} columns={columns} name="cancels" title="Cancels" />
						</div>
						<div className="content">
							<h2>Builder Cancel Rates</h2>
							<FullTable
								data={this.buildCancelRates()}
								columns={columns_rates}
								name="cancel_rates"
								title="Cancel Rates"
								defaultSorted={[{ id: "Cancel Rate", desc: true }]}
							/>
							<h2>Active Lot Cancel Rates</h2>
							<FullTable
								data={this.buildLotCancelRates()}
								columns={columns_lots}
								name="cancel_lots"
								title="Cancel Rates by Lot"
								defaultSorted={[{ id: "Cancels", desc: true }]}
							/>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Cancels)
